import { render, staticRenderFns } from "./structure-list.vue?vue&type=template&id=124eadec&scoped=true"
import script from "./structure-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./structure-list.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./structure-list.vue?vue&type=style&index=0&id=124eadec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124eadec",
  null
  
)

export default component.exports